<template>
  <div v-if="load">
    <div class="contract">
      <div class="title">
        <img class="logo" src="../assets/images/banner_logo.jpg" alt />
      </div>
      <div class="content">
        <h3>合格投资者认定提示</h3>
        <div class="html" v-html="content"></div>
        <div class="column small-12 medium-12 large-12 btns">
          <div class="button" @click="accept">
            <a href="javascript:;">接受</a>
          </div>
          <div class="button" @click="giveup">
            <a href="javascript:;">放弃</a>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { ContractInfo } from "@/api/index";
import Cookies from 'js-cookie'
import Footer from "@/components/contract/footer.vue";
export default {
  components: {
    Footer,
  },
  data() {
    return {
      load: false,
      content: null,
    };
  },
  computed: {},
  watch: {},
  methods: {
    accept() {
      // var inFifteenMinutes = new Date(new Date().getTime() + 1 * 60 * 1000);  
      // 可以替换成inFifteenMinutes测试,inFifteenMinutes是1分钟
      Cookies.set('accept', true, { expires: 1 })
      // expires: 1, 是1天(24小时)
      window.location.href = "/home";
    },
    giveup() {
      Cookies.remove('accept')
    },
  },
  created() {
      this.$emit("hideHeader", false);
      ContractInfo((res) => {
        this.load = true;
        this.$emit("complete", false);
        if (res.code == 0) {
          this.content = res.data.content;
        }
      });
  },
  mounted() {},
};
</script>
<style lang='less' scoped>
.logo {
  max-height: 2rem;
}
.btns {
  margin-top: 2rem;
}
.title {
  border-top: 4px solid #e77500;
  padding: 1rem 3.125rem;
}
.contract {
  .content {
    padding: 6rem 3.125rem 14rem 3.125rem;
    background: url(../assets/images/water.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    .html {
      margin: 0 auto;
      background: url(../assets/images/bottle.png);
      background-repeat: no-repeat;
      background-size: 30vw 30vw;
      background-position: top right;
      /deep/ p {
        border-bottom: 1px dotted #ccc;
      }
    }
    h3 {
      padding-top: 3rem;
      padding-bottom: 1rem;
      margin: 0 auto;
      text-align: center;
    }
    .column {
      text-align: center;
      .button {
        margin: 0 2rem;
      }
    }
  }
}

@media print, screen and (min-width: 40em) {
  .html {
    padding: 2rem 3.125rem 2rem 3.125rem;
  }
  .logo {
    max-height: 2rem;
  }
}
@media print, screen and (min-width: 64.0625em) {
  .html {
    padding: 3rem 4.125rem 3rem 4.125rem;
  }
  .logo {
    max-height: 3rem;
  }
}
@media screen and (min-width: 80em) {
  .html {
    padding: 4rem 5.125rem 4rem 5.125rem;
  }
  .logo {
    max-height: 3rem;
  }
}
@media screen and (max-width: 40em) {
  .title {
    padding: 1rem;
  }
  .btns {
    .button {
      margin: 0 1rem !important;
    }
  }
  .content{
    padding: 4rem 2.125rem 12rem 2.125rem!important;
  }
}
</style>